export default __webpack_public_path__ + "static/media/reverPagoTransparent.32c1ba7e.svg";